import { StyledTooltip } from "@/components/StyledTooltip/StyledTooltip";
import { Box, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { ReactNode } from "react";

interface DropdownOption {
  value: string;
  label: string;
}

type LabelledDropdownProps = {
  label: string;
  options: DropdownOption[];
  value: string;
  tooltip?: React.ReactNode;
  onChange: (event: SelectChangeEvent<string>, child: ReactNode) => void;
};

export const LabelledDropdown: React.FC<LabelledDropdownProps> = ({ label, options, value, onChange, tooltip }) => {
  return (
    <StyledTooltip placement="right" title={tooltip}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          gap: "8px",
          height: "fit-content"
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center"
          }}
        >
          {/* Label */}
          <Typography
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              fontSize: "18px",
              height: "22px",
              width: "180px"
            }}
          >
            {label}:
          </Typography>
        </Box>

        {/* Dropdown */}
        <Box
          sx={{
            paddingLeft: "8px",
            width: "100%", // Ensures the dropdown fills the width of its parent container
            height: "36px"
          }}
        >
          <Select
            value={value}
            onChange={onChange}
            displayEmpty
            sx={{
              width: "100%", // Ensures the dropdown fills the width of its parent container
              borderRadius: "4px",
              height: "36px"
            }}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
    </StyledTooltip>
  );
};
